import React from "react";
import styled from "styled-components";

export default styled.input`
    border: 1px solid #CECEDC;
    width: 100%;
    height: 48px;
    padding: 5px;
    margin-bottom: 12px;
`;